import * as angular from 'angular';

export class BusinessRelationshipsFactory {
    private apiRoot: string = '/api/v2';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    fetchOneClient(haId: string) {
        return this.$http.get(
            `${this.apiRoot}/customers/${haId}/`,
        );
    }

    fetchServiceProviders(params: any) {
        return this.$http.get(
            `${this.apiRoot}/service_providers/`,
            { params }
        );
    }
}

angular
    .module('app')
    .service('BusinessRelationshipsFactory', BusinessRelationshipsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/business-relationships.factory.ts